import { Checkbox, Field } from "@fluentui/react-components";

import BodyPresenceMotion from "./BodyPresenceMotion";

import { useDeviceDrawerStore } from "../../store/DeviceDrawerStore";
import { InputStateProps } from "../../hooks/useDeviceFormHook";
import { DatePicker } from "@fluentui/react-datepicker-compat";

import { DateTime } from "luxon";

type WarrantyInfoProps = {
    styles: string;
    purchaseDateState: InputStateProps<Date>;
    isWarrantyState: InputStateProps<boolean>;
    warrantyDateState: InputStateProps<Date>;
}

const dateFormat = (date?: Date): string => {
    return date ? DateTime.fromJSDate(date).toFormat("dd/MM/yyyy") : "";
}

export default function WarrantyInfo({ styles, purchaseDateState, isWarrantyState, warrantyDateState }: WarrantyInfoProps) {
    const { isForward, level } = useDeviceDrawerStore();

    return (
        <BodyPresenceMotion
            isForward={isForward}
            visible={level === 6}
            unmountOnExit={true}
        >
            <div className={styles}>

                <Field label={"Purchase Date"} required={true}>
                    <DatePicker
                        id={purchaseDateState.id}
                        value={purchaseDateState.value}
                        formatDate={dateFormat}
                        onSelectDate={(date) => purchaseDateState.setValue(date ?? new Date())}
                    />
                </Field>

                <Field label={"Is Warranty"}>
                    <Checkbox
                        id={isWarrantyState.id}
                        checked={isWarrantyState.value}
                        onChange={(_, data) => isWarrantyState.setValue(Boolean(data.checked) ?? false)}
                    />
                </Field>

                <Field label={"Warranty Date"} required={isWarrantyState.value}>
                    <DatePicker
                        disabled={!isWarrantyState.value}
                        id={warrantyDateState.id}
                        value={warrantyDateState.value}
                        formatDate={dateFormat}
                        onSelectDate={(date) => warrantyDateState.setValue(date ?? new Date())}
                    />
                </Field>

            </div>
        </BodyPresenceMotion>
    )
}